import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { chronoDefinedDarkTokens, unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { green, grey } from './colors';

export const radio = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['radio'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          checkedColor: unitySemanticLightColorTokens['--semantic-bg-input-inverse'],
          checkedHoverColor: unitySemanticLightColorTokens['--semantic-bg-input-inverse-hover'],
          checkedBorderColor: unitySemanticLightColorTokens['--semantic-border-inverse'],
          checkedDisabledColor: unitySemanticLightColorTokens['--semantic-text-disabled'],
          checkedDisabledBorderColor: unitySemanticLightColorTokens['--semantic-border-disabled'],
          uncheckedBorderColor: unitySemanticLightColorTokens['--semantic-border-bold'],
          uncheckedHoverBorderColor: unitySemanticLightColorTokens['--semantic-border-inverse'],
          uncheckedDisabledColor: unitySemanticLightColorTokens['--semantic-border-disabled'],
          hoverBackgroundColor: unitySemanticLightColorTokens['--semantic-bg-interactive-neutral-hover'],
        }
      : {
          checkedColor: unitySemanticDarkColorTokens['--semantic-bg-input-inverse'],
          checkedHoverColor: unitySemanticDarkColorTokens['--semantic-bg-input-inverse-hover'],
          checkedBorderColor: chronoDefinedDarkTokens['--component-radio-checked-border'],
          checkedDisabledColor: unitySemanticDarkColorTokens['--semantic-text-disabled'],
          checkedDisabledBorderColor: unitySemanticDarkColorTokens['--semantic-border-disabled'],
          uncheckedBorderColor: chronoDefinedDarkTokens['--component-radio-unchecked-border'],
          uncheckedHoverBorderColor: chronoDefinedDarkTokens['--component-radio-unchecked-hover-border'],
          uncheckedDisabledColor: unitySemanticDarkColorTokens['--semantic-border-disabled'],
          hoverBackgroundColor: unitySemanticDarkColorTokens['--semantic-bg-interactive-neutral-hover'],
        };
  }

  return mode === 'light'
    ? {
        checkedColor: green[600],
        checkedHoverColor: green[500],
        checkedBorderColor: grey[600],
        checkedDisabledColor: grey[300],
        checkedDisabledBorderColor: grey[300],
        uncheckedBorderColor: grey[600],
        uncheckedHoverBorderColor: grey[500],
        uncheckedDisabledColor: grey[300],
        hoverBackgroundColor: grey[50],
      }
    : {
        checkedColor: green[500],
        checkedHoverColor: green[400],
        checkedBorderColor: grey[200],
        checkedDisabledColor: grey[500],
        checkedDisabledBorderColor: grey[400],
        uncheckedBorderColor: grey[200],
        uncheckedHoverBorderColor: grey[300],
        uncheckedDisabledColor: grey[400],
        hoverBackgroundColor: grey[700],
      };
};
